<template>
    
    <div class="col_cover"
        :style="{backgroundImage: cover && cover.server_path ? 'url('+getCoverImgUrl()+')' : ''}">
        <div class="cover_frame">
            <div class="wz_tit">
                <span>춘천도시재생 매거진</span>
                <i>치읓치읓 {{webzine.webzine_title}}</i>
                <img :src="symbolImageUrl" alt="치읏치읏">
            </div>
            <div class="wz_foot">
                <!-- <span>{{getPublishDate()}}</span> -->
                <!-- <i>{{webzine.webzine_title}}</i> -->
                <!-- <p style="border: none;">Chuncheon Urban Regeneration News Magazine</p> -->
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import Vue from "vue";

export default {
    name: "WebZineViewToc",
    computed:{
        ...mapGetters('webzineView',[
            'coverImgUrl',
            'mode',
            'cover',
            'webzine'
        ])
    },
    data() {
        return {
            symbolImageUrl: this.$baseURL + '/images/webzine/logo-webzine-symbol.svg',
        }
    },
    methods:{
        getCoverImgUrl(){
            if(this.cover && this.cover.server_path){
                return [
                    Vue.prototype.$baseURL
                    , 'image' + this.cover.server_path
                    , this.cover.new_name
                ].join('/');
            }

            return '';
        },

        getPublishDate(){
            const dateObj = new Date(this.webzine.publish_date);
            return dateObj.getFullYear();
        }
    }
}
</script>

<style scoped>

.wz_cont .col_wrap .col_cover::before{
    background-color: inherit;
}
.wz-cover-image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
}

.main-side-bar img {
    width: 25px;
    margin-bottom: 10px;
    margin-right: 11px;
}

.main-side-bar > a > div {
    font-weight: 300;
    width: 500px;
    transform: rotate(90deg);
    text-align: center;
}

</style>
